import { useState, useMemo, useCallback, useEffect } from "react";
import { obtenerToken } from '../lib/auth';

// ═══════════════════════════════════════════════════════════════════
// TABLAS HISTÓRICAS DE TIPOS DE INTERÉS
// ═══════════════════════════════════════════════════════════════════

const INTERES_LEGAL = [
  { from: "2023-01-01", to: "2026-12-31", rate: 3.25 },
  { from: "2016-01-01", to: "2022-12-31", rate: 3.0 },
  { from: "2015-01-01", to: "2015-12-31", rate: 3.5 },
  { from: "2014-01-01", to: "2014-12-31", rate: 4.0 },
  { from: "2013-01-01", to: "2013-12-31", rate: 4.0 },
  { from: "2012-01-01", to: "2012-12-31", rate: 4.0 },
  { from: "2011-01-01", to: "2011-12-31", rate: 4.0 },
  { from: "2010-01-01", to: "2010-12-31", rate: 4.0 },
  { from: "2009-04-01", to: "2009-12-31", rate: 4.0 },
  { from: "2009-01-01", to: "2009-03-31", rate: 5.5 },
  { from: "2008-01-01", to: "2008-12-31", rate: 5.5 },
  { from: "2007-01-01", to: "2007-12-31", rate: 5.0 },
  { from: "2006-01-01", to: "2006-12-31", rate: 4.0 },
  { from: "2005-01-01", to: "2005-12-31", rate: 4.0 },
  { from: "2004-01-01", to: "2004-12-31", rate: 3.75 },
  { from: "2003-01-01", to: "2003-12-31", rate: 4.25 },
  { from: "2002-01-01", to: "2002-12-31", rate: 4.25 },
  { from: "2001-01-01", to: "2001-12-31", rate: 5.5 },
  { from: "2000-01-01", to: "2000-12-31", rate: 4.25 },
  { from: "1999-01-01", to: "1999-12-31", rate: 4.25 },
  { from: "1998-01-01", to: "1998-12-31", rate: 5.5 },
  { from: "1997-01-01", to: "1997-12-31", rate: 7.5 },
  { from: "1996-01-01", to: "1996-12-31", rate: 9.0 },
  { from: "1995-01-01", to: "1995-12-31", rate: 9.0 },
  { from: "1994-01-01", to: "1994-12-31", rate: 9.0 },
  { from: "1993-01-01", to: "1993-12-31", rate: 10.0 },
  { from: "1992-01-01", to: "1992-12-31", rate: 10.0 },
  { from: "1991-01-01", to: "1991-12-31", rate: 10.0 },
  { from: "1990-06-30", to: "1990-12-31", rate: 10.0 },
  { from: "1990-01-01", to: "1990-06-29", rate: 9.0 },
  { from: "1989-01-01", to: "1989-12-31", rate: 9.0 },
  { from: "1988-01-01", to: "1988-12-31", rate: 9.0 },
  { from: "1987-01-01", to: "1987-12-31", rate: 9.5 },
  { from: "1986-01-01", to: "1986-12-31", rate: 10.5 },
  { from: "1985-01-01", to: "1985-12-31", rate: 11.0 },
];

const INTERES_MOROSIDAD_COMERCIAL = [
  { from: "2026-01-01", to: "2026-06-30", rate: 10.15 },
  { from: "2025-07-01", to: "2025-12-31", rate: 10.15 },
  { from: "2025-01-01", to: "2025-06-30", rate: 11.15 },
  { from: "2024-07-01", to: "2024-12-31", rate: 12.25 },
  { from: "2024-01-01", to: "2024-06-30", rate: 12.5 },
  { from: "2023-07-01", to: "2023-12-31", rate: 12.0 },
  { from: "2023-01-01", to: "2023-06-30", rate: 10.5 },
  { from: "2022-07-01", to: "2022-12-31", rate: 8.0 },
  { from: "2022-01-01", to: "2022-06-30", rate: 8.0 },
  { from: "2021-07-01", to: "2021-12-31", rate: 8.0 },
  { from: "2021-01-01", to: "2021-06-30", rate: 8.0 },
  { from: "2020-07-01", to: "2020-12-31", rate: 8.0 },
  { from: "2020-01-01", to: "2020-06-30", rate: 8.0 },
  { from: "2019-07-01", to: "2019-12-31", rate: 8.0 },
  { from: "2019-01-01", to: "2019-06-30", rate: 8.0 },
  { from: "2018-07-01", to: "2018-12-31", rate: 8.0 },
  { from: "2018-01-01", to: "2018-06-30", rate: 8.0 },
  { from: "2017-07-01", to: "2017-12-31", rate: 8.0 },
  { from: "2017-01-01", to: "2017-06-30", rate: 8.0 },
  { from: "2016-07-01", to: "2016-12-31", rate: 8.0 },
  { from: "2016-01-01", to: "2016-06-30", rate: 8.05 },
  { from: "2015-07-01", to: "2015-12-31", rate: 8.05 },
  { from: "2015-01-01", to: "2015-06-30", rate: 8.05 },
  { from: "2014-07-01", to: "2014-12-31", rate: 8.15 },
  { from: "2014-01-01", to: "2014-06-30", rate: 8.25 },
  { from: "2013-07-01", to: "2013-12-31", rate: 8.5 },
  { from: "2013-02-24", to: "2013-06-30", rate: 8.75 },
  { from: "2013-01-01", to: "2013-02-23", rate: 7.75 },
  { from: "2012-07-01", to: "2012-12-31", rate: 8.0 },
  { from: "2012-01-01", to: "2012-06-30", rate: 8.0 },
  { from: "2011-07-01", to: "2011-12-31", rate: 8.25 },
  { from: "2011-01-01", to: "2011-06-30", rate: 8.0 },
  { from: "2010-07-01", to: "2010-12-31", rate: 8.0 },
  { from: "2010-01-01", to: "2010-06-30", rate: 8.0 },
  { from: "2009-07-01", to: "2009-12-31", rate: 8.0 },
  { from: "2009-01-01", to: "2009-06-30", rate: 9.5 },
  { from: "2008-07-01", to: "2008-12-31", rate: 11.07 },
  { from: "2008-01-01", to: "2008-06-30", rate: 11.2 },
  { from: "2007-07-01", to: "2007-12-31", rate: 11.07 },
  { from: "2007-01-01", to: "2007-06-30", rate: 10.58 },
  { from: "2006-07-01", to: "2006-12-31", rate: 9.83 },
  { from: "2006-01-01", to: "2006-06-30", rate: 9.25 },
  { from: "2005-07-01", to: "2005-12-31", rate: 9.05 },
  { from: "2005-01-01", to: "2005-06-30", rate: 9.09 },
  { from: "2004-07-01", to: "2004-12-31", rate: 9.01 },
  { from: "2004-01-01", to: "2004-06-30", rate: 9.02 },
  { from: "2003-07-01", to: "2003-12-31", rate: 9.1 },
  { from: "2003-01-01", to: "2003-06-30", rate: 9.85 },
];

// Copias base inmutables + inyección de tipos configurables (años venideros).
const _BASE_LEGAL = INTERES_LEGAL.slice();
const _BASE_MOROSIDAD = INTERES_MOROSIDAD_COMERCIAL.slice();
function aplicarTiposConfig(ov) {
  const rebuild = (arr, base, extra) => {
    arr.length = 0;
    (extra || []).forEach((e) => { if (e && e.from && e.to && e.rate != null) arr.push({ from: e.from, to: e.to, rate: +e.rate }); });
    base.forEach((e) => arr.push(e));
  };
  rebuild(INTERES_LEGAL, _BASE_LEGAL, ov && ov.legal);
  rebuild(INTERES_MOROSIDAD_COMERCIAL, _BASE_MOROSIDAD, ov && ov.morosidad_comercial);
}

// ═══════════════════════════════════════════════════════════════════
// UTILIDADES
// ═══════════════════════════════════════════════════════════════════

function parseDate(str) {
  if (!str) return null;
  const [y, m, d] = str.split("-").map(Number);
  return new Date(y, m - 1, d);
}

function daysBetween(d1, d2) {
  const t1 = Date.UTC(d1.getFullYear(), d1.getMonth(), d1.getDate());
  const t2 = Date.UTC(d2.getFullYear(), d2.getMonth(), d2.getDate());
  return Math.round((t2 - t1) / 86400000);
}

function fmtDate(d) {
  if (!d) return "\u2014";
  return `${String(d.getDate()).padStart(2, "0")}/${String(d.getMonth() + 1).padStart(2, "0")}/${d.getFullYear()}`;
}

function fmtMoney(n) {
  return n.toLocaleString("es-ES", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " \u20AC";
}

function getRateForDate(table, date) {
  for (const entry of table) {
    if (date >= parseDate(entry.from) && date <= parseDate(entry.to)) return entry.rate;
  }
  return null;
}

function splitByRatePeriods(table, startDate, endDate) {
  const periods = [];
  let current = new Date(startDate);
  while (current < endDate) {
    let rate = null;
    let periodEnd = new Date(endDate);
    for (const entry of table) {
      const from = parseDate(entry.from);
      const to = parseDate(entry.to);
      if (current >= from && current <= to) {
        rate = entry.rate;
        const entryEnd = new Date(to);
        entryEnd.setDate(entryEnd.getDate() + 1);
        if (entryEnd < endDate) periodEnd = entryEnd;
        break;
      }
    }
    if (rate === null) {
      current.setDate(current.getDate() + 1);
      continue;
    }
    const days = daysBetween(current, periodEnd);
    if (days > 0) periods.push({ from: new Date(current), to: new Date(periodEnd.getTime() - 86400000), days, rate });
    current = new Date(periodEnd);
  }
  return periods;
}

function derivedTable(base, offset) {
  return base.map((e) => ({ ...e, rate: +(e.rate + offset).toFixed(4) }));
}
function demoraAdminTable(base) {
  return base.map((e) => ({ ...e, rate: +(e.rate * 1.25).toFixed(4) }));
}

function getTable(tipoId, tipoPactado) {
  switch (tipoId) {
    case "legal":
      return INTERES_LEGAL;
    case "judicial":
      return derivedTable(INTERES_LEGAL, 2);
    case "pactado":
      return [{ from: "1985-01-01", to: "2099-12-31", rate: tipoPactado || 0 }];
    case "demora_admin":
      return demoraAdminTable(INTERES_LEGAL);
    case "morosidad_comercial":
      return INTERES_MOROSIDAD_COMERCIAL;
    case "demora_subvenciones":
      return demoraAdminTable(INTERES_LEGAL);
    case "seguro_auto":
      return INTERES_LEGAL;
    case "art19_lgcu":
      return INTERES_LEGAL;
    default:
      return INTERES_LEGAL;
  }
}

function calcArt19Periods(capital, start, end, fechaCondena) {
  const rows = [];
  if (!fechaCondena || fechaCondena >= end) {
    splitByRatePeriods(INTERES_LEGAL, start, end).forEach((p) => {
      rows.push({ ...p, rate: +(p.rate * 1.5).toFixed(4), phase: "Legal \u00D7 1,5 (art. 19.1 LGCU)", baseRate: p.rate });
    });
    return rows;
  }
  const twoYearsFromCondena = new Date(fechaCondena);
  twoYearsFromCondena.setFullYear(twoYearsFromCondena.getFullYear() + 2);
  const phase1End = twoYearsFromCondena < end ? twoYearsFromCondena : end;
  splitByRatePeriods(INTERES_LEGAL, start, phase1End).forEach((p) => {
    rows.push({ ...p, rate: +(p.rate * 1.5).toFixed(4), phase: "Legal \u00D7 1,5", baseRate: p.rate });
  });
  if (twoYearsFromCondena < end) {
    splitByRatePeriods(INTERES_LEGAL, twoYearsFromCondena, end).forEach((p) => {
      const art19Rate = Math.max(+(p.rate * 1.5).toFixed(4), 20);
      const label = art19Rate >= 20 ? "M\u00EDn. 20% (>2a desde condena)" : "Legal \u00D7 1,5 (>2a desde condena)";
      rows.push({ ...p, rate: art19Rate, phase: label, baseRate: p.rate });
    });
  }
  return rows;
}

function calcLCSPeriods(capital, start, end) {
  const twoYears = new Date(start);
  twoYears.setFullYear(twoYears.getFullYear() + 2);
  const rows = [];
  const p1End = twoYears < end ? twoYears : end;
  splitByRatePeriods(INTERES_LEGAL, start, p1End).forEach((p) => {
    rows.push({ ...p, rate: Math.max(p.rate * 2, 20), phase: "0\u20132 a\u00F1os (legal\u00D72, m\u00EDn 20%)", baseRate: p.rate });
  });
  if (twoYears < end) {
    splitByRatePeriods(derivedTable(INTERES_LEGAL, 20), twoYears, end).forEach((p) => {
      rows.push({ ...p, phase: "Desde 3er a\u00F1o (legal+20pp)" });
    });
  }
  return rows;
}

function calcPeriodInterest(capital, periods) {
  let total = 0;
  const rows = periods.map((p) => {
    const interest = (capital * p.rate * p.days) / (365 * 100);
    total += interest;
    return { ...p, interest };
  });
  return { rows, total };
}

// ═══════════════════════════════════════════════════════════════════
// TIPOS + ESTILOS
// ═══════════════════════════════════════════════════════════════════

const TYPES = [
  { id: "legal", name: "Legal", icon: "\u2696\uFE0F", desc: "Art. 1108 CC", color: "#1B3A5C" },
  { id: "judicial", name: "Judicial (576 LEC)", icon: "\uD83C\uDFDB\uFE0F", desc: "Legal + 2pp", color: "#6B3A8A" },
  { id: "pactado", name: "Pactado", icon: "\uD83D\uDCDD", desc: "Tipo fijo convenido", color: "#8B6914" },
  { id: "demora_admin", name: "Demora Admin.", icon: "\uD83C\uDFE2", desc: "Art. 26.6 LGT (legal\u00D71,25)", color: "#2D6A4F" },
  { id: "morosidad_comercial", name: "Morosidad Comercial", icon: "\uD83C\uDFED", desc: "Ley 3/2004 (BCE+8pp)", color: "#9B2C2C" },
  { id: "demora_subvenciones", name: "Subvenciones", icon: "\uD83D\uDCCB", desc: "Art. 37.1 Ley 38/2003", color: "#4A5568" },
  { id: "seguro_auto", name: "Art. 20 LCS", icon: "\uD83D\uDE97", desc: "Seguro / Autom\u00F3vil", color: "#C53030" },
  { id: "art19_lgcu", name: "Art. 19 LGCU", icon: "\uD83D\uDEE1\uFE0F", desc: "Consumidores (legal\u00D71,5 / m\u00EDn 20%)", color: "#B7791F" },
];

const P = { bg: "#F7F6F3", card: "#FFFFFF", primary: "#1B3A5C", primaryLight: "#2A5580", accent: "#C4A35A", text: "#2D2D2D", muted: "#6B7280", border: "#D6D3CC", success: "#1A6B4A", successBg: "#E8F5EE", inputBg: "#FAFAF8", warn: "#92400E" };
const F = { display: "'Georgia','Times New Roman',serif", body: "'Segoe UI',system-ui,-apple-system,sans-serif", mono: "'Consolas','Courier New',monospace" };
const lbl = { display: "block", fontSize: 11, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.08em", color: P.muted, marginBottom: 6 };
const inp = { width: "100%", padding: "10px 12px", border: `1px solid ${P.border}`, borderRadius: 6, fontSize: 15, fontFamily: F.body, background: P.inputBg, color: P.text, boxSizing: "border-box" };
const crd = { background: P.card, borderRadius: 10, border: `1px solid ${P.border}`, padding: "20px", marginBottom: 14 };

// ═══════════════════════════════════════════════════════════════════
// SUB-COMPONENTES
// ═══════════════════════════════════════════════════════════════════

function BreakdownTable({ label, labelColor, rows, totalDays, totalInterest, showPhase }) {
  if (!rows || !rows.length) return null;
  return (
    <div style={{ marginBottom: 16 }}>
      <div style={{ fontSize: 12, fontWeight: 700, color: labelColor || P.muted, marginBottom: 8 }}>{label}</div>
      <div style={{ overflowX: "auto" }}>
        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12, fontFamily: F.body }}>
          <thead>
            <tr style={{ borderBottom: `2px solid ${P.border}`, textAlign: "left" }}>
              <th style={{ padding: "5px 6px", fontWeight: 700, color: P.muted, fontSize: 10 }}>DESDE</th>
              <th style={{ padding: "5px 6px", fontWeight: 700, color: P.muted, fontSize: 10 }}>HASTA</th>
              <th style={{ padding: "5px 6px", fontWeight: 700, color: P.muted, fontSize: 10, textAlign: "right" }}>D\u00CDAS</th>
              <th style={{ padding: "5px 6px", fontWeight: 700, color: P.muted, fontSize: 10, textAlign: "right" }}>TIPO %</th>
              <th style={{ padding: "5px 6px", fontWeight: 700, color: P.muted, fontSize: 10, textAlign: "right" }}>INTERESES</th>
              {showPhase && <th style={{ padding: "5px 6px", fontWeight: 700, color: P.muted, fontSize: 10 }}>FASE</th>}
            </tr>
          </thead>
          <tbody>
            {rows.map((r, i) => (
              <tr key={i} style={{ borderBottom: `1px solid ${P.border}33`, background: i % 2 ? P.inputBg : "transparent" }}>
                <td style={{ padding: "6px", fontFamily: F.mono, fontSize: 11 }}>{fmtDate(r.from)}</td>
                <td style={{ padding: "6px", fontFamily: F.mono, fontSize: 11 }}>{fmtDate(r.to)}</td>
                <td style={{ padding: "6px", textAlign: "right" }}>{r.days}</td>
                <td style={{ padding: "6px", textAlign: "right", fontWeight: 600, color: labelColor || P.primary }}>{r.rate.toFixed(2)}%</td>
                <td style={{ padding: "6px", textAlign: "right", fontWeight: 600 }}>{fmtMoney(r.interest)}</td>
                {showPhase && <td style={{ padding: "6px", fontSize: 10, color: P.muted }}>{r.phase || ""}</td>}
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr style={{ borderTop: `2px solid ${P.border}`, fontWeight: 700 }}>
              <td colSpan={2} style={{ padding: "7px 6px" }}>SUBTOTAL</td>
              <td style={{ padding: "7px 6px", textAlign: "right" }}>{totalDays}</td>
              <td style={{ padding: "7px 6px" }}></td>
              <td style={{ padding: "7px 6px", textAlign: "right", color: P.success }}>{fmtMoney(totalInterest)}</td>
              {showPhase && <td></td>}
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  );
}

function TypeSelector({ value, onChange, label: sLabel }) {
  return (
    <div>
      <label style={lbl}>{sLabel}</label>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(150px, 1fr))", gap: 6 }}>
        {TYPES.map((t) => (
          <button
            key={t.id}
            type="button"
            data-testid={`interes-tipo-${t.id}`}
            onClick={() => onChange(t.id)}
            style={{
              display: "flex", alignItems: "center", gap: 6, padding: "8px 10px",
              border: `2px solid ${value === t.id ? t.color : P.border}`, borderRadius: 7,
              background: value === t.id ? t.color : "transparent",
              color: value === t.id ? "white" : P.text, cursor: "pointer",
              fontFamily: F.body, fontSize: 12, fontWeight: value === t.id ? 600 : 400,
              textAlign: "left", transition: "all 0.15s",
            }}
          >
            <span style={{ fontSize: 16 }}>{t.icon}</span>
            <div>
              <div style={{ fontWeight: 600, fontSize: 12, lineHeight: 1.2 }}>{t.name}</div>
              <div style={{ fontSize: 9, opacity: value === t.id ? 0.85 : 0.55, marginTop: 1 }}>{t.desc}</div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}

// ═══════════════════════════════════════════════════════════════════
// PARSER DE LENGUAJE NATURAL (local regex + IA vía backend de la app)
// ═══════════════════════════════════════════════════════════════════

function parseSpanishDate(s) {
  if (!s) return null;
  let m = s.match(/(\d{1,2})[/\-.](\d{1,2})[/\-.](\d{4})/);
  if (m) return `${m[3]}-${m[2].padStart(2, "0")}-${m[1].padStart(2, "0")}`;
  m = s.match(/(\d{4})-(\d{1,2})-(\d{1,2})/);
  if (m) return `${m[1]}-${m[2].padStart(2, "0")}-${m[3].padStart(2, "0")}`;
  const MESES = {
    enero: "01", febrero: "02", marzo: "03", abril: "04", mayo: "05", junio: "06",
    julio: "07", agosto: "08", septiembre: "09", setembre: "09", octubre: "10", novembre: "11",
    noviembre: "11", diciembre: "12", desembre: "12", gener: "01", febrer: "02", "mar\u00E7": "03",
    maig: "05", juny: "06", juliol: "07", agost: "08",
  };
  m = s.match(/(\d{1,2})\s*(?:de\s+|d')?\s*([a-z\u00E1\u00E9\u00ED\u00F3\u00FA\u00FC\u00E7\u00F1]+)\s*(?:de\s+|del?\s+)?(\d{4})/i);
  if (m && MESES[m[2].toLowerCase()]) {
    return `${m[3]}-${MESES[m[2].toLowerCase()]}-${m[1].padStart(2, "0")}`;
  }
  return null;
}

function localParseNL(text) {
  const t = text.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  const result = {};

  if (/morosidad|comercial|ley\s*3\/2004|bce/.test(t)) result.tipoPre = "morosidad_comercial";
  else if (/judicial|576|mora\s*procesal/.test(t)) result.tipoPre = "judicial";
  else if (/pactado|convenido/.test(t)) result.tipoPre = "pactado";
  else if (/demora\s*(admin|tribut|hacienda|lgt)/.test(t)) result.tipoPre = "demora_admin";
  else if (/subvenci/.test(t)) result.tipoPre = "demora_subvenciones";
  else if (/seguro|automovil|lcs|art[.\s]*20/.test(t)) result.tipoPre = "seguro_auto";
  else if (/lgcu|consumidor|19\.1|art[.\s]*19|clausula\s*abusiva/.test(t)) result.tipoPre = "art19_lgcu";
  else if (/legal|1108/.test(t)) result.tipoPre = "legal";

  if (/moratori|dos\s*tramos|sentencia.*pago|pre.*post|hasta\s*sentencia/.test(t)) {
    result.dosTramos = true;
  }
  if (/legal.*moratori|moratori.*legal/.test(t)) {
    result.tipoPre = "legal";
    result.tipoPost = "judicial";
    result.dosTramos = true;
  }

  const rawText = text;
  let cm = rawText.match(/(\d[\d.,]*)\s*(?:\u20AC|euros?|EUR)/i);
  if (!cm) cm = rawText.match(/(?:capital|importe|cantidad|principal)\s*(?:de\s+)?(\d[\d.,]*)/i);
  if (!cm) cm = rawText.match(/(?:de\s+)(\d[\d.,]*)\s*(?:\u20AC|euros?)/i);
  if (cm) {
    result.capital = cm[1].replace(/\./g, "").replace(",", ".");
  }

  const pr = rawText.match(/pactado\s*(?:al?\s*)?(\d+[.,]?\d*)\s*%/i);
  if (pr) result.tipoPactado = pr[1].replace(",", ".");

  const datePatterns = [
    /(?:desde|fecha\s*inicio|inicio|de|des\s*de|del?)\s+(.+?)\s+(?:hasta|a|fins?\s*a|fecha\s*fin|al?)\s+(.+?)(?:\.|$|,|\s+sentencia)/i,
    /(?:inicio|inici)\s+(.+?)\s+(?:fin|final|fi)\s+(.+?)(?:\.|$|,)/i,
  ];

  for (const dp of datePatterns) {
    const dm = rawText.match(dp);
    if (dm) {
      const d1 = parseSpanishDate(dm[1].trim());
      const d2 = parseSpanishDate(dm[2].trim());
      if (d1) result.fechaDesde = d1;
      if (d2) result.fechaHasta = d2;
      break;
    }
  }

  const sm = rawText.match(/(?:sentencia|condena)\s*(?:del?\s*)?(\d{1,2}[/\-.]?\d{1,2}[/\-.]?\d{4}|\d{1,2}\s+(?:de\s+)?[a-z\u00E1\u00E9\u00ED\u00F3\u00FA\u00FC\u00E7\u00F1]+\s+(?:de\s+)?\d{4})/i);
  if (sm) {
    const sd = parseSpanishDate(sm[1]);
    if (sd) {
      result.fechaSentencia = sd;
      if (result.tipoPre !== "art19_lgcu") result.dosTramos = true;
    }
  }

  return Object.keys(result).length > 0 ? result : null;
}

// IA vía el backend de la app (Emergent LLM Key / proveedor configurado en Ajustes → Asistente IA)
async function apiParseNL(text) {
  const API = process.env.REACT_APP_BACKEND_URL || "";
  const token = obtenerToken();
  const hoy = new Date().toISOString().slice(0, 10);
  try {
    const res = await fetch(`${API}/api/intereses/parse-nl`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
      body: JSON.stringify({ texto: text, hoy }),
    });
    if (!res.ok) return null;
    const data = await res.json();
    return data.params || null;
  } catch (e) {
    console.error("parse-nl error:", e);
    return null;
  }
}

// ═══════════════════════════════════════════════════════════════════
// PRINCIPAL
// ═══════════════════════════════════════════════════════════════════

export default function CalculadoraIntereses() {
  const today = new Date().toISOString().slice(0, 10);
  const [tipoPre, setTipoPre] = useState("legal");
  const [capital, setCapital] = useState("10000");
  const [fechaDesde, setFechaDesde] = useState("2024-01-01");
  const [fechaSentencia, setFechaSentencia] = useState("");
  const [fechaHasta, setFechaHasta] = useState(today);
  const [tipoPactado, setTipoPactado] = useState("5");
  const [usarDosTramos, setUsarDosTramos] = useState(true);
  const [tipoPost, setTipoPost] = useState("judicial");
  const [tipoPactadoPost, setTipoPactadoPost] = useState("5");
  const [resultado, setResultado] = useState(null);
  const [showTable, setShowTable] = useState(false);
  const [concepto, setConcepto] = useState("");
  const [ops, setOps] = useState([]);  // conceptos acumulados para el informe

  // --- Escrito de proposición de intereses ---
  const [showEscrito, setShowEscrito] = useState(false);
  const [plantillas, setPlantillas] = useState([]);
  const [carpetas, setCarpetas] = useState([]);
  const [plantillaSel, setPlantillaSel] = useState("");
  const [expQuery, setExpQuery] = useState("");
  const [expOpciones, setExpOpciones] = useState([]);
  const [expSel, setExpSel] = useState(null);
  const [descargarDoc, setDescargarDoc] = useState(true);
  const [genEscrito, setGenEscrito] = useState(false);
  const [escritoRes, setEscritoRes] = useState(null);
  const [escritoErr, setEscritoErr] = useState("");

  const [nlText, setNlText] = useState("");
  const [nlLoading, setNlLoading] = useState(false);
  const [nlFeedback, setNlFeedback] = useState(null);
  const [inputMode, setInputMode] = useState("form");

  // --- Histórico (multi-dispositivo) ---
  const [showHist, setShowHist] = useState(false);
  const [histCalculos, setHistCalculos] = useState([]);
  const [histInformes, setHistInformes] = useState([]);
  const [histLoading, setHistLoading] = useState(false);

  // --- Tipos de interés configurables (años venideros) ---
  const [tiposConfig, setTiposConfig] = useState({ legal: [], morosidad_comercial: [] });
  const [puedeEditarTipos, setPuedeEditarTipos] = useState(false);
  const [showTipos, setShowTipos] = useState(false);
  const [tiposVer, setTiposVer] = useState(0);
  const [nuevoTipo, setNuevoTipo] = useState({ tabla: "legal", fecha_desde: "", fecha_hasta: "", tasa: "" });
  const [tipoErr, setTipoErr] = useState("");

  const selectedPre = TYPES.find((t) => t.id === tipoPre);
  const selectedPost = TYPES.find((t) => t.id === tipoPost);
  const reset = () => setResultado(null);
  const isArt19 = tipoPre === "art19_lgcu";

  const applyParsed = useCallback((params) => {
    if (!params) return;
    if (params.tipoPre) setTipoPre(params.tipoPre);
    if (params.tipoPost) setTipoPost(params.tipoPost);
    if (params.capital) setCapital(String(params.capital));
    if (params.fechaDesde) setFechaDesde(params.fechaDesde);
    if (params.fechaHasta) setFechaHasta(params.fechaHasta);
    if (params.fechaSentencia) setFechaSentencia(params.fechaSentencia);
    if (params.dosTramos !== undefined) setUsarDosTramos(!!params.dosTramos);
    if (params.tipoPactado) setTipoPactado(String(params.tipoPactado));
    setResultado(null);
  }, []);

  const handleNLSubmit = useCallback(async () => {
    if (!nlText.trim()) return;
    setNlLoading(true);
    setNlFeedback(null);

    const local = localParseNL(nlText);
    if (local && local.capital && local.fechaDesde) {
      applyParsed(local);
      setNlFeedback({ ok: true, msg: "Par\u00E1metros extra\u00EDdos correctamente.", source: "local" });
      setNlLoading(false);
      setInputMode("form");
      return;
    }

    const ai = await apiParseNL(nlText);
    if (ai) {
      const merged = { ...ai, ...Object.fromEntries(Object.entries(local || {}).filter(([, v]) => v != null)) };
      applyParsed(merged);
      setNlFeedback({ ok: true, msg: "Par\u00E1metros extra\u00EDdos con IA. Revisa el formulario antes de calcular.", source: "ai" });
      setInputMode("form");
    } else {
      setNlFeedback({ ok: false, msg: "No he podido extraer los par\u00E1metros. Intenta con m\u00E1s detalle (capital, fechas, tipo de inter\u00E9s)." });
    }
    setNlLoading(false);
  }, [nlText, applyParsed]);

  const currentRates = useMemo(() => {
    const now = new Date();
    const legal = getRateForDate(INTERES_LEGAL, now);
    const judicial = legal !== null ? legal + 2 : null;
    const demora = legal !== null ? +(legal * 1.25).toFixed(2) : null;
    const morosidad = getRateForDate(INTERES_MOROSIDAD_COMERCIAL, now);
    return { legal, judicial, demora, morosidad };
  }, [tiposVer]);

  const calcular = useCallback(() => {
    const cap = parseFloat(capital);
    if (isNaN(cap) || cap <= 0) {
      setResultado({ error: "El capital debe ser un n\u00FAmero positivo." });
      return;
    }
    const dDesde = parseDate(fechaDesde);
    const dHasta = parseDate(fechaHasta);

    if (!dDesde || !dHasta || dDesde >= dHasta) {
      setResultado({ error: "La fecha final debe ser posterior a la fecha inicial." });
      return;
    }

    // Art. 19.1 LGCU: régimen propio (desplaza 1108 CC y 576 LEC)
    if (isArt19) {
      const dCond = fechaSentencia ? parseDate(fechaSentencia) : null;
      if (dCond && (dCond < dDesde || dCond > dHasta)) {
        setResultado({ error: "La fecha de condena debe estar entre el abono y la restitución." });
        return;
      }
      const r = calcPeriodInterest(cap, calcArt19Periods(cap, dDesde, dHasta, dCond));
      setResultado({
        capital: cap, fechaDesde: dDesde, fechaSentencia: dCond, fechaCondena: dCond, fechaHasta: dHasta,
        isArt19: true,
        totalDays: daysBetween(dDesde, dHasta),
        preDays: daysBetween(dDesde, dHasta), preRows: r.rows, preTotalInterest: r.total,
        preLabel: "Art. 19.1 LGCU", preColor: "#B7791F",
        postDays: 0, postRows: null, postTotalInterest: 0,
        postLabel: "", postColor: "#B7791F",
        totalInterest: r.total, totalWithCapital: cap + r.total, hasTwoPhases: false,
      });
      return;
    }

    const dSent = usarDosTramos && fechaSentencia ? parseDate(fechaSentencia) : null;
    if (dSent && (dSent <= dDesde || dSent > dHasta)) {
      setResultado({ error: "La fecha de sentencia debe estar entre las fechas inicial y final." });
      return;
    }

    const endT1 = dSent || dHasta;
    let preRows, preTotalInterest;
    if (tipoPre === "seguro_auto") {
      const r = calcPeriodInterest(cap, calcLCSPeriods(cap, dDesde, endT1));
      preRows = r.rows;
      preTotalInterest = r.total;
    } else {
      const table1 = getTable(tipoPre, parseFloat(tipoPactado));
      const r = calcPeriodInterest(cap, splitByRatePeriods(table1, dDesde, endT1));
      preRows = r.rows;
      preTotalInterest = r.total;
    }
    const preDays = daysBetween(dDesde, endT1);

    let postRows = null;
    let postTotalInterest = 0;
    let postDays = 0;
    if (dSent && dSent < dHasta) {
      postDays = daysBetween(dSent, dHasta);
      if (tipoPost === "seguro_auto") {
        const r = calcPeriodInterest(cap, calcLCSPeriods(cap, dSent, dHasta));
        postRows = r.rows;
        postTotalInterest = r.total;
      } else {
        const table2 = getTable(tipoPost, parseFloat(tipoPactadoPost));
        const r = calcPeriodInterest(cap, splitByRatePeriods(table2, dSent, dHasta));
        postRows = r.rows;
        postTotalInterest = r.total;
      }
    }

    setResultado({
      capital: cap, fechaDesde: dDesde, fechaSentencia: dSent, fechaHasta: dHasta,
      totalDays: daysBetween(dDesde, dHasta),
      preDays, preRows, preTotalInterest,
      preLabel: selectedPre?.name || tipoPre, preColor: selectedPre?.color || P.primary,
      postDays, postRows, postTotalInterest,
      postLabel: selectedPost?.name || tipoPost, postColor: selectedPost?.color || P.primary,
      totalInterest: preTotalInterest + postTotalInterest,
      totalWithCapital: cap + preTotalInterest + postTotalInterest,
      hasTwoPhases: !!dSent && dSent < dHasta,
    });
  }, [capital, fechaDesde, fechaSentencia, fechaHasta, tipoPre, tipoPost, tipoPactado, tipoPactadoPost, usarDosTramos, selectedPre, selectedPost, isArt19]);

  // ── Escrito de proposición de intereses ──
  const API = process.env.REACT_APP_BACKEND_URL || "";
  const authToken = () => obtenerToken();
  const [descargaErr, setDescargaErr] = useState("");

  // La API exige token: una pestaña nueva no lo envía, así que se descarga el
  // fichero con la petición autenticada y se entrega como blob.
  const descargarDocumento = useCallback(async (url, nombre) => {
    setDescargaErr("");
    try {
      const res = await fetch(`${API}${url}`, { headers: { Authorization: `Bearer ${authToken()}` } });
      if (!res.ok) {
        setDescargaErr(res.status === 401
          ? "Tu sesión ha caducado. Vuelve a entrar y repite la descarga."
          : `No se pudo descargar el documento (error ${res.status}).`);
        return;
      }
      const blob = await res.blob();
      const href = window.URL.createObjectURL(blob);
      const enlace = document.createElement("a");
      enlace.href = href;
      enlace.download = nombre || (url.split("/").pop() || "documento.docx");
      document.body.appendChild(enlace);
      enlace.click();
      enlace.remove();
      setTimeout(() => window.URL.revokeObjectURL(href), 5000);
    } catch (e) {
      setDescargaErr("Error de conexión al descargar el documento.");
    }
  }, [API]);

  const abrirEscrito = useCallback(async () => {
    const nuevo = !showEscrito;
    setShowEscrito(nuevo);
    setEscritoRes(null);
    setEscritoErr("");
    if (nuevo && plantillas.length === 0) {
      try {
        const [rp, rc] = await Promise.all([
          fetch(`${API}/api/plantillas-word/`, { headers: { Authorization: `Bearer ${authToken()}` } }),
          fetch(`${API}/api/plantillas-word/carpetas`, { headers: { Authorization: `Bearer ${authToken()}` } }),
        ]);
        const dp = await rp.json();
        const dc = await rc.json();
        const lista = dp.data || dp || [];
        setPlantillas(lista);
        setCarpetas(dc.data || dc || []);
        const propuesta = lista.find((p) => /propuesta.*inter|04\s*-\s*propuesta|intereses/i.test(p.nombre || ""));
        if (propuesta) setPlantillaSel(String(propuesta.id));
      } catch (e) {
        setEscritoErr("No se pudieron cargar las plantillas.");
      }
    }
  }, [showEscrito, plantillas.length, API]);

  const buscarExp = useCallback(async (q) => {
    setExpQuery(q);
    setExpSel(null);
    if (q.length < 2) { setExpOpciones([]); return; }
    try {
      const res = await fetch(`${API}/api/expedientes?search=${encodeURIComponent(q)}&limit=8`, {
        headers: { Authorization: `Bearer ${authToken()}` },
      });
      const data = await res.json();
      setExpOpciones(data.data || data || []);
    } catch (e) { setExpOpciones([]); }
  }, [API]);

  const buildInteresesPayload = useCallback(() => {
    if (!resultado || resultado.error) return null;
    const filas = [];
    (resultado.preRows || []).forEach((r) => filas.push({
      tramo: resultado.hasTwoPhases ? "\u2460" : "",
      desde: fmtDate(r.from), hasta: fmtDate(r.to), dias: r.days,
      tipo: r.rate, interes: +Number(r.interest).toFixed(2),
    }));
    if (resultado.hasTwoPhases) (resultado.postRows || []).forEach((r) => filas.push({
      tramo: "\u2461",
      desde: fmtDate(r.from), hasta: fmtDate(r.to), dias: r.days,
      tipo: r.rate, interes: +Number(r.interest).toFixed(2),
    }));
    return {
      capital: resultado.capital,
      fechaDesde: fmtDate(resultado.fechaDesde),
      fechaHasta: fmtDate(resultado.fechaHasta),
      fechaSentencia: resultado.fechaSentencia ? fmtDate(resultado.fechaSentencia) : null,
      totalDias: resultado.totalDays,
      tipoPreLabel: resultado.preLabel,
      tipoPostLabel: resultado.hasTwoPhases ? resultado.postLabel : null,
      preTotal: +Number(resultado.preTotalInterest).toFixed(2),
      postTotal: +Number(resultado.postTotalInterest || 0).toFixed(2),
      totalInteres: +Number(resultado.totalInterest).toFixed(2),
      totalConCapital: +Number(resultado.totalWithCapital).toFixed(2),
      hasTwoPhases: !!resultado.hasTwoPhases,
      filas,
    };
  }, [resultado]);

  const generarEscrito = useCallback(async () => {
    setEscritoErr("");
    setEscritoRes(null);
    if (!plantillaSel) { setEscritoErr("Selecciona una plantilla."); return; }
    if (!expSel) { setEscritoErr("Selecciona un expediente."); return; }
    let conceptos = ops.map(({ _id, ...rest }) => rest);
    if (conceptos.length === 0) {
      const actual = buildInteresesPayload();
      if (actual) conceptos = [{ ...actual, concepto: (concepto || "").trim() || "Intereses" }];
    }
    if (conceptos.length === 0) { setEscritoErr("Primero calcula o añade intereses al informe."); return; }
    setGenEscrito(true);
    try {
      const res = await fetch(`${API}/api/intereses/generar-escrito`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${authToken()}` },
        body: JSON.stringify({ plantillaId: Number(plantillaSel), expedienteId: expSel.id, conceptos }),
      });
      const data = await res.json();
      if (!res.ok) { setEscritoErr(data.detail || "Error al generar el escrito."); }
      else {
        setEscritoRes(data);
        guardarHistorial(
          "informe",
          `${conceptos.length} concepto(s) · escrito ${expSel && expSel.numero_expediente ? expSel.numero_expediente : ""}`.trim(),
          { ops: conceptos }
        );
        if (descargarDoc && data.documento && data.documento.url) {
          descargarDocumento(data.documento.url, data.documento.nombre);
        }
      }
    } catch (e) { setEscritoErr("Error de conexión."); }
    setGenEscrito(false);
  }, [plantillaSel, expSel, buildInteresesPayload, descargarDoc, API, ops, concepto, descargarDocumento]);

  // Acumular conceptos e informe de liquidación independiente
  const addToReport = useCallback(() => {
    const payload = buildInteresesPayload();
    if (!payload) return;
    const nombre = (concepto || "").trim() || `Concepto ${ops.length + 1}`;
    const item = { ...payload, concepto: nombre };
    setOps((prev) => [...prev, { ...item, _id: Date.now() + Math.random() }]);
    // Guardar en el histórico (cálculo individual, recuperable)
    guardarHistorial(
      "calculo",
      `${nombre} · ${fmtMoney(payload.capital)} · int. ${fmtMoney(payload.totalInteres)}`,
      { form: formSnapshot(), concepto: nombre, payload: item }
    );
    setConcepto("");
    setResultado(null);
    setShowTable(false);
  }, [buildInteresesPayload, concepto, ops.length]);

  const removeOp = useCallback((id) => setOps((prev) => prev.filter((o) => o._id !== id)), []);

  const opsTotals = useCallback(() => {
    const cap = ops.reduce((s, o) => s + (+o.capital || 0), 0);
    const inte = ops.reduce((s, o) => s + (+o.totalInteres || 0), 0);
    return { cap, inte, tot: cap + inte };
  }, [ops]);

  const descargarInforme = useCallback(async () => {
    let conceptos = ops.map(({ _id, ...rest }) => rest);
    if (conceptos.length === 0) {
      const actual = buildInteresesPayload();
      if (actual) conceptos = [{ ...actual, concepto: (concepto || "").trim() || "Intereses" }];
    }
    if (conceptos.length === 0) return;
    try {
      const res = await fetch(`${API}/api/intereses/informe-liquidacion`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${authToken()}` },
        body: JSON.stringify({ conceptos }),
      });
      const data = await res.json();
      if (res.ok && data.documento && data.documento.url) {
        guardarHistorial("informe", `${conceptos.length} concepto(s) · informe liquidación`, { ops: conceptos });
        await descargarDocumento(data.documento.url, data.documento.nombre);
      } else {
        setDescargaErr((data && data.detail) || "No se pudo generar el informe de liquidación.");
      }
    } catch (e) { setDescargaErr("Error de conexión al generar el informe."); }
  }, [ops, buildInteresesPayload, concepto, API, descargarDocumento]);

  // ── Histórico multi-dispositivo ──────────────────────────────────────────
  const formSnapshot = useCallback(() => ({
    tipoPre, capital, fechaDesde, fechaSentencia, fechaHasta,
    tipoPactado, usarDosTramos, tipoPost, tipoPactadoPost,
  }), [tipoPre, capital, fechaDesde, fechaSentencia, fechaHasta, tipoPactado, usarDosTramos, tipoPost, tipoPactadoPost]);

  const guardarHistorial = useCallback(async (tipo, etiqueta, datos) => {
    try {
      await fetch(`${API}/api/intereses/historial`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${authToken()}` },
        body: JSON.stringify({ tipo, etiqueta: (etiqueta || "").slice(0, 300), datos: datos || {} }),
      });
    } catch (e) { /* el histórico no debe bloquear el flujo */ }
  }, [API]);

  const cargarHistorial = useCallback(async () => {
    setHistLoading(true);
    try {
      const res = await fetch(`${API}/api/intereses/historial`, {
        headers: { Authorization: `Bearer ${authToken()}` },
      });
      const data = await res.json();
      if (res.ok) {
        setHistCalculos(data.calculos || []);
        setHistInformes(data.informes || []);
      }
    } catch (e) { /* noop */ }
    setHistLoading(false);
  }, [API]);

  const abrirHistorial = useCallback(() => {
    const next = !showHist;
    setShowHist(next);
    if (next) cargarHistorial();
  }, [showHist, cargarHistorial]);

  const borrarHistorial = useCallback(async (hid) => {
    try {
      await fetch(`${API}/api/intereses/historial/${hid}`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${authToken()}` },
      });
      cargarHistorial();
    } catch (e) { /* noop */ }
  }, [API, cargarHistorial]);

  const recuperarCalculo = useCallback((item) => {
    const f = (item && item.datos && item.datos.form) || {};
    if (f.tipoPre) setTipoPre(f.tipoPre);
    if (f.capital !== undefined) setCapital(String(f.capital));
    if (f.fechaDesde !== undefined) setFechaDesde(f.fechaDesde || "");
    if (f.fechaSentencia !== undefined) setFechaSentencia(f.fechaSentencia || "");
    if (f.fechaHasta !== undefined) setFechaHasta(f.fechaHasta || "");
    if (f.tipoPactado !== undefined) setTipoPactado(String(f.tipoPactado));
    if (f.usarDosTramos !== undefined) setUsarDosTramos(!!f.usarDosTramos);
    if (f.tipoPost) setTipoPost(f.tipoPost);
    if (f.tipoPactadoPost !== undefined) setTipoPactadoPost(String(f.tipoPactadoPost));
    setConcepto((item && item.datos && item.datos.concepto) || "");
    setResultado(null);
    setInputMode("form");
    setShowHist(false);
  }, []);

  const recuperarInforme = useCallback((item) => {
    const arr = (item && item.datos && item.datos.ops) || [];
    setOps(arr.map((o) => ({ ...o, _id: Date.now() + Math.random() })));
    setShowHist(false);
    setResultado(null);
  }, []);

  // ── Nuevo cálculo: reset TOTAL para empezar de cero ──────────────────────
  const nuevoCalculoTodo = useCallback(() => {
    setTipoPre("legal");
    setCapital("10000");
    setFechaDesde("2024-01-01");
    setFechaSentencia("");
    setFechaHasta(today);
    setTipoPactado("5");
    setUsarDosTramos(true);
    setTipoPost("judicial");
    setTipoPactadoPost("5");
    setResultado(null);
    setShowTable(false);
    setConcepto("");
    setOps([]);
    setShowEscrito(false);
    setPlantillaSel("");
    setExpQuery("");
    setExpOpciones([]);
    setExpSel(null);
    setEscritoRes(null);
    setEscritoErr("");
    setNlText("");
    setNlFeedback(null);
    setInputMode("form");
    setShowHist(false);
  }, [today]);

  // ── Tipos de interés configurables ───────────────────────────────────────
  const cargarTipos = useCallback(async () => {
    try {
      const res = await fetch(`${API}/api/intereses/tipos`, { headers: { Authorization: `Bearer ${authToken()}` } });
      const data = await res.json();
      if (res.ok) {
        const ov = { legal: data.legal || [], morosidad_comercial: data.morosidad_comercial || [] };
        setTiposConfig(ov);
        setPuedeEditarTipos(!!data.puede_editar);
        aplicarTiposConfig(ov);
        setTiposVer((v) => v + 1);
      }
    } catch (e) { /* se usan las tablas base */ }
  }, [API]);

  useEffect(() => { cargarTipos(); }, [cargarTipos]);

  const guardarTipo = useCallback(async () => {
    setTipoErr("");
    const { tabla, fecha_desde, fecha_hasta, tasa } = nuevoTipo;
    if (!fecha_desde || !fecha_hasta || tasa === "" || isNaN(+tasa)) {
      setTipoErr("Completa las fechas (desde/hasta) y la tasa (%)."); return;
    }
    try {
      const res = await fetch(`${API}/api/intereses/tipos`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${authToken()}` },
        body: JSON.stringify({ tabla, fecha_desde, fecha_hasta, tasa: +tasa }),
      });
      if (!res.ok) { const d = await res.json().catch(() => ({})); setTipoErr(d.detail || "No se pudo guardar."); return; }
      setNuevoTipo({ tabla, fecha_desde: "", fecha_hasta: "", tasa: "" });
      cargarTipos();
    } catch (e) { setTipoErr("Error de conexión."); }
  }, [API, nuevoTipo, cargarTipos]);

  const borrarTipo = useCallback(async (id) => {
    try {
      await fetch(`${API}/api/intereses/tipos/${id}`, { method: "DELETE", headers: { Authorization: `Bearer ${authToken()}` } });
      cargarTipos();
    } catch (e) { /* noop */ }
  }, [API, cargarTipos]);

  return (
    <div style={{ background: P.bg, borderRadius: 12, fontFamily: F.body, color: P.text, overflow: "hidden", border: `1px solid ${P.border}` }} data-testid="calculadora-intereses">
      {/* Header */}
      <div style={{ background: `linear-gradient(135deg, ${P.primary} 0%, ${P.primaryLight} 100%)`, padding: "24px 20px 18px", color: "white" }}>
        <div style={{ maxWidth: 1100, margin: "0 auto" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <span style={{ fontSize: 26 }}>💰</span>
            <h1 style={{ fontFamily: F.display, fontSize: 21, fontWeight: 700, margin: 0 }}>Cálculo de Intereses Judiciales</h1>
          </div>
          <p style={{ fontSize: 12, opacity: 0.8, margin: "4px 0 0 36px", fontStyle: "italic" }}>
            Dos tramos: hasta sentencia + mora procesal (art. 576 LEC)
          </p>
          <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginTop: 10, marginLeft: 36 }}>
            {currentRates.legal !== null && <span style={{ padding: "2px 9px", borderRadius: 12, background: "rgba(255,255,255,0.15)", fontSize: 10, fontWeight: 600 }}>Legal {currentRates.legal}%</span>}
            {currentRates.judicial !== null && <span style={{ padding: "2px 9px", borderRadius: 12, background: "rgba(255,255,255,0.15)", fontSize: 10, fontWeight: 600 }}>Judicial {currentRates.judicial}%</span>}
            {currentRates.demora !== null && <span style={{ padding: "2px 9px", borderRadius: 12, background: "rgba(255,255,255,0.15)", fontSize: 10, fontWeight: 600 }}>Demora {currentRates.demora}%</span>}
            {currentRates.morosidad !== null && <span style={{ padding: "2px 9px", borderRadius: 12, background: "rgba(255,255,255,0.15)", fontSize: 10, fontWeight: 600 }}>Morosidad {currentRates.morosidad}%</span>}
          </div>
        </div>
      </div>

      <div style={{ maxWidth: 1100, margin: "0 auto", padding: "18px 14px 28px" }}>
        {/* ACCIONES GLOBALES: Nuevo cálculo + Histórico */}
        <div style={{ display: "flex", gap: 10, flexWrap: "wrap", marginBottom: 14 }}>
          <button
            data-testid="interes-nuevo-calculo"
            onClick={nuevoCalculoTodo}
            title="Resetear todo y empezar de cero"
            style={{ display: "flex", alignItems: "center", gap: 6, background: P.card, color: P.primary, border: `1px solid ${P.primary}55`, borderRadius: 8, padding: "9px 16px", fontWeight: 700, cursor: "pointer", fontFamily: F.body, fontSize: 13 }}
          >
            🆕 Nuevo cálculo
          </button>
          <button
            data-testid="interes-historial-btn"
            onClick={abrirHistorial}
            title="Recuperar cálculos e informes recientes (últimos 10)"
            style={{ display: "flex", alignItems: "center", gap: 6, background: showHist ? P.primary : P.card, color: showHist ? "white" : P.primary, border: `1px solid ${P.primary}55`, borderRadius: 8, padding: "9px 16px", fontWeight: 700, cursor: "pointer", fontFamily: F.body, fontSize: 13 }}
          >
            📚 Histórico
          </button>
          {puedeEditarTipos && (
            <button
              data-testid="interes-tipos-btn"
              onClick={() => setShowTipos((s) => !s)}
              title="Configurar tipos de interés de años venideros (2027, 2028, …)"
              style={{ display: "flex", alignItems: "center", gap: 6, background: showTipos ? P.primary : P.card, color: showTipos ? "white" : P.primary, border: `1px solid ${P.primary}55`, borderRadius: 8, padding: "9px 16px", fontWeight: 700, cursor: "pointer", fontFamily: F.body, fontSize: 13 }}
            >
              ⚙️ Tipos de interés
            </button>
          )}
        </div>

        {/* PANEL TIPOS DE INTERÉS CONFIGURABLES */}
        {showTipos && puedeEditarTipos && (
          <div style={{ ...crd, borderLeft: `4px solid ${P.primary}` }} data-testid="interes-tipos-panel">
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 6 }}>
              <div style={{ fontSize: 14, fontWeight: 700, color: P.text }}>⚙️ Tipos de interés (años venideros)</div>
              <button onClick={() => setShowTipos(false)} style={{ background: "none", border: "none", cursor: "pointer", color: P.muted, fontSize: 18, fontWeight: 700, lineHeight: 1 }}>×</button>
            </div>
            <div style={{ fontSize: 11, color: P.muted, marginBottom: 12, lineHeight: 1.6 }}>
              Añade aquí el <strong>interés legal</strong> y el de <strong>morosidad comercial</strong> de los próximos años.
              El resto se calcula solo: <strong>judicial</strong> = legal + 2 pp · <strong>demora / subvenciones</strong> = legal × 1,25 · <strong>seguro / art. 19</strong> derivan del legal.
              Las fechas van en formato <code>AAAA-MM-DD</code> (p. ej. legal 2027: desde <code>2027-01-01</code> hasta <code>2027-12-31</code>).
            </div>

            {/* Formulario alta */}
            <div style={{ display: "flex", gap: 8, flexWrap: "wrap", alignItems: "flex-end", marginBottom: 14, padding: "10px 12px", background: P.inputBg, borderRadius: 8 }}>
              <div>
                <div style={{ fontSize: 10, color: P.muted, marginBottom: 3 }}>Tabla</div>
                <select data-testid="interes-tipo-tabla" value={nuevoTipo.tabla} onChange={(e) => setNuevoTipo({ ...nuevoTipo, tabla: e.target.value })}
                  style={{ padding: "7px 9px", borderRadius: 6, border: `1px solid ${P.border}`, fontSize: 12, background: "white" }}>
                  <option value="legal">Interés legal</option>
                  <option value="morosidad_comercial">Morosidad comercial</option>
                </select>
              </div>
              <div>
                <div style={{ fontSize: 10, color: P.muted, marginBottom: 3 }}>Desde</div>
                <input data-testid="interes-tipo-desde" type="date" value={nuevoTipo.fecha_desde} onChange={(e) => setNuevoTipo({ ...nuevoTipo, fecha_desde: e.target.value })}
                  style={{ padding: "6px 9px", borderRadius: 6, border: `1px solid ${P.border}`, fontSize: 12 }} />
              </div>
              <div>
                <div style={{ fontSize: 10, color: P.muted, marginBottom: 3 }}>Hasta</div>
                <input data-testid="interes-tipo-hasta" type="date" value={nuevoTipo.fecha_hasta} onChange={(e) => setNuevoTipo({ ...nuevoTipo, fecha_hasta: e.target.value })}
                  style={{ padding: "6px 9px", borderRadius: 6, border: `1px solid ${P.border}`, fontSize: 12 }} />
              </div>
              <div>
                <div style={{ fontSize: 10, color: P.muted, marginBottom: 3 }}>Tasa %</div>
                <input data-testid="interes-tipo-tasa" type="number" step="0.01" placeholder="3.25" value={nuevoTipo.tasa} onChange={(e) => setNuevoTipo({ ...nuevoTipo, tasa: e.target.value })}
                  style={{ width: 90, padding: "6px 9px", borderRadius: 6, border: `1px solid ${P.border}`, fontSize: 12 }} />
              </div>
              <button data-testid="interes-tipo-guardar" onClick={guardarTipo}
                style={{ background: P.primary, color: "white", border: "none", borderRadius: 6, padding: "8px 16px", fontWeight: 700, cursor: "pointer", fontSize: 12 }}>
                + Añadir
              </button>
            </div>
            {tipoErr && <div style={{ color: "#C53030", fontSize: 12, marginBottom: 10 }} data-testid="interes-tipo-error">{tipoErr}</div>}

            {/* Listas */}
            <div style={{ display: "flex", gap: 18, flexWrap: "wrap" }}>
              {["legal", "morosidad_comercial"].map((tab) => (
                <div key={tab} style={{ flex: 1, minWidth: 280 }}>
                  <div style={{ fontSize: 12, fontWeight: 700, color: P.primary, marginBottom: 8, textTransform: "uppercase", letterSpacing: "0.05em" }}>
                    {tab === "legal" ? "Interés legal" : "Morosidad comercial"}
                  </div>
                  {(tiposConfig[tab] || []).length === 0 && <div style={{ fontSize: 12, color: P.muted }}>Sin tipos añadidos (se usa la tabla oficial integrada).</div>}
                  <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                    {(tiposConfig[tab] || []).map((it) => (
                      <div key={it.id} data-testid={`interes-tipo-item-${it.id}`} style={{ display: "flex", alignItems: "center", gap: 8, padding: "7px 10px", background: P.inputBg, borderRadius: 8, fontSize: 12 }}>
                        <div style={{ flex: 1 }}>{it.from} → {it.to}</div>
                        <div style={{ fontWeight: 700, color: P.primary }}>{it.rate}%</div>
                        <button onClick={() => borrarTipo(it.id)} title="Eliminar" style={{ background: "none", border: "none", color: "#C53030", cursor: "pointer", fontWeight: 700, fontSize: 15 }}>×</button>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* PANEL HISTÓRICO */}
        {showHist && (
          <div style={{ ...crd, borderLeft: `4px solid ${P.accent}` }} data-testid="interes-historial-panel">
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 10 }}>
              <div style={{ fontSize: 14, fontWeight: 700, color: P.text }}>📚 Histórico (últimos 10 de cada tipo)</div>
              <button onClick={() => setShowHist(false)} style={{ background: "none", border: "none", cursor: "pointer", color: P.muted, fontSize: 18, fontWeight: 700, lineHeight: 1 }}>×</button>
            </div>
            {histLoading && <div style={{ fontSize: 12, color: P.muted }}>Cargando…</div>}
            {!histLoading && (
              <div style={{ display: "flex", gap: 18, flexWrap: "wrap" }}>
                <div style={{ flex: 1, minWidth: 300 }}>
                  <div style={{ fontSize: 12, fontWeight: 700, color: P.primary, marginBottom: 8, textTransform: "uppercase", letterSpacing: "0.05em" }}>Cálculos individuales</div>
                  {histCalculos.length === 0 && <div style={{ fontSize: 12, color: P.muted }}>Sin cálculos guardados todavía.</div>}
                  <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                    {histCalculos.map((it, i) => (
                      <div key={it.id} data-testid={`interes-hist-calculo-${i}`} style={{ display: "flex", alignItems: "center", gap: 8, padding: "8px 10px", background: P.inputBg, borderRadius: 8, fontSize: 12 }}>
                        <div style={{ flex: 1, minWidth: 0 }}>
                          <div style={{ fontWeight: 700, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{it.etiqueta || "Cálculo"}</div>
                          <div style={{ color: P.muted, fontSize: 10 }}>{(it.created_at || "").slice(0, 16).replace("T", " ")}</div>
                        </div>
                        <button data-testid={`interes-hist-recuperar-calc-${i}`} onClick={() => recuperarCalculo(it)} style={{ background: P.primary, color: "white", border: "none", borderRadius: 6, padding: "5px 10px", fontWeight: 700, cursor: "pointer", fontSize: 11, whiteSpace: "nowrap" }}>Recuperar</button>
                        <button onClick={() => borrarHistorial(it.id)} title="Eliminar" style={{ background: "none", border: "none", color: "#C53030", cursor: "pointer", fontWeight: 700, fontSize: 15 }}>×</button>
                      </div>
                    ))}
                  </div>
                </div>
                <div style={{ flex: 1, minWidth: 300 }}>
                  <div style={{ fontSize: 12, fontWeight: 700, color: P.success, marginBottom: 8, textTransform: "uppercase", letterSpacing: "0.05em" }}>Informes acumulados</div>
                  {histInformes.length === 0 && <div style={{ fontSize: 12, color: P.muted }}>Sin informes guardados todavía.</div>}
                  <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                    {histInformes.map((it, i) => (
                      <div key={it.id} data-testid={`interes-hist-informe-${i}`} style={{ display: "flex", alignItems: "center", gap: 8, padding: "8px 10px", background: P.successBg, borderRadius: 8, fontSize: 12 }}>
                        <div style={{ flex: 1, minWidth: 0 }}>
                          <div style={{ fontWeight: 700, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{it.etiqueta || "Informe"}</div>
                          <div style={{ color: P.muted, fontSize: 10 }}>{(it.created_at || "").slice(0, 16).replace("T", " ")}</div>
                        </div>
                        <button data-testid={`interes-hist-recuperar-inf-${i}`} onClick={() => recuperarInforme(it)} style={{ background: P.success, color: "white", border: "none", borderRadius: 6, padding: "5px 10px", fontWeight: 700, cursor: "pointer", fontSize: 11, whiteSpace: "nowrap" }}>Recuperar</button>
                        <button onClick={() => borrarHistorial(it.id)} title="Eliminar" style={{ background: "none", border: "none", color: "#C53030", cursor: "pointer", fontWeight: 700, fontSize: 15 }}>×</button>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}
          </div>
        )}

        {/* MODE TOGGLE */}
        <div style={{ display: "flex", gap: 0, marginBottom: 14, borderRadius: 10, overflow: "hidden", border: `1px solid ${P.border}` }}>
          <button
            data-testid="interes-modo-texto"
            onClick={() => setInputMode("text")}
            style={{ flex: 1, padding: "10px 14px", border: "none", cursor: "pointer", fontFamily: F.body, fontSize: 13, fontWeight: 600, background: inputMode === "text" ? P.primary : P.card, color: inputMode === "text" ? "white" : P.muted, transition: "all 0.15s", display: "flex", alignItems: "center", justifyContent: "center", gap: 6 }}
          >
            <span style={{ fontSize: 16 }}>💬</span> Escribir instrucción
          </button>
          <button
            data-testid="interes-modo-formulario"
            onClick={() => setInputMode("form")}
            style={{ flex: 1, padding: "10px 14px", border: "none", cursor: "pointer", fontFamily: F.body, fontSize: 13, fontWeight: 600, background: inputMode === "form" ? P.primary : P.card, color: inputMode === "form" ? "white" : P.muted, transition: "all 0.15s", display: "flex", alignItems: "center", justifyContent: "center", gap: 6 }}
          >
            <span style={{ fontSize: 16 }}>📋</span> Formulario
          </button>
        </div>

        {/* NATURAL LANGUAGE INPUT */}
        {inputMode === "text" && (
          <div style={{ ...crd, borderLeft: `4px solid ${P.accent}`, padding: "18px 20px" }}>
            <label style={{ ...lbl, color: P.accent, marginBottom: 10 }}>Describe el cálculo en lenguaje natural</label>
            <textarea
              data-testid="interes-nl-textarea"
              value={nlText}
              onChange={(e) => setNlText(e.target.value)}
              onKeyDown={(e) => { if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); handleNLSubmit(); } }}
              placeholder={'Ej: "Calcula intereses legales y moratorios de 15.000€ desde 01/03/2023 hasta hoy, sentencia 10/01/2025"\n\nEj: "Interés judicial de 8.500€ del 15/06/2024 al 21/07/2026"\n\nEj: "Morosidad comercial de 25.000€ desde 1 de enero de 2024 hasta 30 de junio de 2026"'}
              style={{ ...inp, minHeight: 90, resize: "vertical", fontSize: 14, lineHeight: 1.5, fontFamily: F.body }}
            />
            <div style={{ display: "flex", gap: 10, alignItems: "center", marginTop: 10 }}>
              <button
                data-testid="interes-nl-submit"
                onClick={handleNLSubmit}
                disabled={nlLoading || !nlText.trim()}
                style={{ padding: "10px 20px", border: "none", borderRadius: 8, cursor: nlLoading ? "wait" : "pointer", background: nlLoading ? P.muted : P.accent, color: "white", fontFamily: F.body, fontSize: 14, fontWeight: 700, opacity: !nlText.trim() ? 0.5 : 1 }}
              >
                {nlLoading ? "Procesando..." : "Interpretar y rellenar formulario →"}
              </button>
              <span style={{ fontSize: 11, color: P.muted }}>Enter para enviar</span>
            </div>

            {nlFeedback && (
              <div style={{ marginTop: 10, padding: "8px 12px", borderRadius: 6, background: nlFeedback.ok ? P.successBg : "#FFF5F5", border: `1px solid ${nlFeedback.ok ? P.success + "44" : "#C5303044"}`, fontSize: 12, color: nlFeedback.ok ? P.success : "#C53030", display: "flex", alignItems: "center", gap: 6 }} data-testid="interes-nl-feedback">
                <span>{nlFeedback.ok ? "✓" : "⚠️"}</span>
                {nlFeedback.msg}
                {nlFeedback.source === "ai" && <span style={{ fontSize: 10, opacity: 0.7 }}> (IA)</span>}
                {nlFeedback.source === "local" && <span style={{ fontSize: 10, opacity: 0.7 }}> (instantáneo)</span>}
              </div>
            )}

            <div style={{ marginTop: 10, fontSize: 11, color: P.muted, lineHeight: 1.6 }}>
              <strong>Formatos de fecha:</strong> 01/03/2024 · 1-3-2024 · 1 de marzo de 2024 · 2024-03-01<br />
              <strong>Tipos reconocidos:</strong> legal · judicial · moratorio · pactado al X% · morosidad comercial · demora admin · LCS / seguro · subvenciones · art. 19 LGCU (consumidores)
            </div>
          </div>
        )}

        {/* FORM MODE */}
        {inputMode === "form" && isArt19 && (
          <div style={{ ...crd, borderLeft: "4px solid #B7791F" }}>
            <div style={{ fontSize: 13, fontWeight: 700, color: "#B7791F", marginBottom: 14, display: "flex", alignItems: "center", gap: 6 }}>
              <span style={{ fontSize: 18 }}>🛡️</span>
              Art. 19.1 LGCU — Indemnización por mora del empresario
            </div>

            <TypeSelector value={tipoPre} onChange={(v) => { setTipoPre(v); reset(); }} label="Tipo de interés" />

            <div style={{ marginTop: 12, padding: "10px 14px", background: "#B7791F11", borderRadius: 8, border: "1px solid #B7791F33", fontSize: 12, lineHeight: 1.6, color: P.text }}>
              <strong style={{ color: "#B7791F" }}>Régimen especial (desplaza art. 1108 CC y art. 576 LEC):</strong><br />
              Interés legal × 1,5 desde el abono por el consumidor hasta la restitución completa. Transcurridos 2 años desde la condena, mínimo 20% anual. Los intereses se producen por días.
            </div>

            <div style={{ marginTop: 16 }}>
              <label style={lbl}>Capital a restituir (€)</label>
              <input type="number" step="0.01" min="0" data-testid="interes-capital" value={capital} onChange={(e) => { setCapital(e.target.value); reset(); }} style={{ ...inp, maxWidth: 220 }} />
            </div>

            <div style={{ display: "flex", gap: 12, flexWrap: "wrap", marginTop: 14 }}>
              <div style={{ flex: 1, minWidth: 150 }}>
                <label style={lbl}>Fecha de abono por el consumidor</label>
                <input type="date" data-testid="interes-fecha-desde" value={fechaDesde} onChange={(e) => { setFechaDesde(e.target.value); reset(); }} style={inp} />
                <div style={{ fontSize: 10, color: P.muted, marginTop: 3 }}>Dies a quo: fecha del cargo indebido</div>
              </div>
              <div style={{ flex: 1, minWidth: 150 }}>
                <label style={lbl}>Fecha de la condena (sentencia)</label>
                <input type="date" data-testid="interes-fecha-condena" value={fechaSentencia} onChange={(e) => { setFechaSentencia(e.target.value); reset(); }} style={inp} />
                <div style={{ fontSize: 10, color: P.muted, marginTop: 3 }}>Referencia para el mínimo del 20% a los 2 años</div>
              </div>
              <div style={{ flex: 1, minWidth: 150 }}>
                <label style={lbl}>Fecha de restitución (pago)</label>
                <input type="date" data-testid="interes-fecha-hasta" value={fechaHasta} onChange={(e) => { setFechaHasta(e.target.value); reset(); }} style={inp} />
                <div style={{ fontSize: 10, color: P.muted, marginTop: 3 }}>Dies ad quem: día del pago total</div>
              </div>
            </div>
          </div>
        )}

        {/* FORM MODE (resto de tipos) */}
        {inputMode === "form" && !isArt19 && (
          <>
            {/* Toggle dos tramos */}
            <div style={{ ...crd, display: "flex", alignItems: "center", gap: 10, padding: "14px 18px" }}>
              <input type="checkbox" id="dosTramos" data-testid="interes-dos-tramos" checked={usarDosTramos} onChange={(e) => { setUsarDosTramos(e.target.checked); reset(); }} style={{ width: 18, height: 18, accentColor: P.primary, cursor: "pointer" }} />
              <label htmlFor="dosTramos" style={{ cursor: "pointer", fontSize: 14, lineHeight: 1.3 }}>
                <strong>Cálculo en dos tramos</strong>
                <span style={{ color: P.muted, fontSize: 12, display: "block" }}>Tramo 1 hasta sentencia + Tramo 2 mora procesal hasta pago completo</span>
              </label>
            </div>

            {/* TRAMO 1 */}
            <div style={{ ...crd, borderLeft: `4px solid ${selectedPre?.color || P.primary}` }}>
              <div style={{ fontSize: 13, fontWeight: 700, color: selectedPre?.color || P.primary, marginBottom: 14, display: "flex", alignItems: "center", gap: 6 }}>
                <span style={{ background: selectedPre?.color || P.primary, color: "white", borderRadius: "50%", width: 22, height: 22, display: "inline-flex", alignItems: "center", justifyContent: "center", fontSize: 12, fontWeight: 800 }}>1</span>
                {usarDosTramos ? "Tramo pre-sentencia" : "Período de cálculo"}
              </div>

              <TypeSelector value={tipoPre} onChange={(v) => { setTipoPre(v); reset(); }} label="Tipo de interés" />

              {tipoPre === "pactado" && (
                <div style={{ marginTop: 14 }}>
                  <label style={lbl}>Tipo pactado (% anual)</label>
                  <input type="number" step="0.01" min="0" max="100" value={tipoPactado} onChange={(e) => { setTipoPactado(e.target.value); reset(); }} style={{ ...inp, maxWidth: 160 }} />
                </div>
              )}

              <div style={{ marginTop: 16 }}>
                <label style={lbl}>Capital (€)</label>
                <input type="number" step="0.01" min="0" data-testid="interes-capital" value={capital} onChange={(e) => { setCapital(e.target.value); reset(); }} style={{ ...inp, maxWidth: 220 }} />
              </div>

              <div style={{ display: "flex", gap: 12, flexWrap: "wrap", marginTop: 14 }}>
                <div style={{ flex: 1, minWidth: 150 }}>
                  <label style={lbl}>Fecha desde (dies a quo)</label>
                  <input type="date" data-testid="interes-fecha-desde" value={fechaDesde} onChange={(e) => { setFechaDesde(e.target.value); reset(); }} style={inp} />
                </div>
                {usarDosTramos ? (
                  <div style={{ flex: 1, minWidth: 150 }}>
                    <label style={lbl}>Fecha sentencia 1ª instancia</label>
                    <input type="date" data-testid="interes-fecha-sentencia" value={fechaSentencia} onChange={(e) => { setFechaSentencia(e.target.value); reset(); }} style={inp} />
                  </div>
                ) : (
                  <div style={{ flex: 1, minWidth: 150 }}>
                    <label style={lbl}>Fecha hasta</label>
                    <input type="date" data-testid="interes-fecha-hasta" value={fechaHasta} onChange={(e) => { setFechaHasta(e.target.value); reset(); }} style={inp} />
                  </div>
                )}
              </div>
            </div>

            {/* TRAMO 2 */}
            {usarDosTramos && (
              <div style={{ ...crd, borderLeft: `4px solid ${selectedPost?.color || P.primary}` }}>
                <div style={{ fontSize: 13, fontWeight: 700, color: selectedPost?.color || P.primary, marginBottom: 14, display: "flex", alignItems: "center", gap: 6 }}>
                  <span style={{ background: selectedPost?.color || P.primary, color: "white", borderRadius: "50%", width: 22, height: 22, display: "inline-flex", alignItems: "center", justifyContent: "center", fontSize: 12, fontWeight: 800 }}>2</span>
                  Tramo post-sentencia (mora procesal)
                </div>

                <TypeSelector value={tipoPost} onChange={(v) => { setTipoPost(v); reset(); }} label="Tipo de interés post-sentencia" />

                {tipoPost === "pactado" && (
                  <div style={{ marginTop: 14 }}>
                    <label style={lbl}>Tipo pactado post-sentencia (% anual)</label>
                    <input type="number" step="0.01" min="0" max="100" value={tipoPactadoPost} onChange={(e) => { setTipoPactadoPost(e.target.value); reset(); }} style={{ ...inp, maxWidth: 160 }} />
                  </div>
                )}

                <div style={{ marginTop: 14 }}>
                  <label style={lbl}>Fecha hasta (pago completo)</label>
                  <input type="date" data-testid="interes-fecha-hasta-tramo2" value={fechaHasta} onChange={(e) => { setFechaHasta(e.target.value); reset(); }} style={{ ...inp, maxWidth: 220 }} />
                </div>

                <div style={{ marginTop: 12, padding: "8px 12px", background: `${P.warn}11`, borderRadius: 6, border: `1px solid ${P.warn}22`, fontSize: 11, lineHeight: 1.5, color: P.warn }}>
                  <strong>Art. 576 LEC:</strong> Desde que fuere dictada en primera instancia, toda sentencia que condene al pago de cantidad líquida determinará el devengo de un interés anual igual al del interés legal del dinero incrementado en dos puntos o el que corresponda por pacto o disposición especial.
                </div>
              </div>
            )}
          </>
        )}

        {/* CALCULAR */}
        <button
          data-testid="interes-calcular-btn"
          onClick={calcular}
          style={{ width: "100%", padding: "14px", background: `linear-gradient(135deg, ${P.primary} 0%, ${P.primaryLight} 100%)`, color: "white", border: "none", borderRadius: 10, fontSize: 16, fontWeight: 700, fontFamily: F.body, cursor: "pointer", marginBottom: 20, boxShadow: `0 2px 8px ${P.primary}44` }}
        >
          Calcular intereses
        </button>

        {/* ERROR */}
        {resultado?.error && (
          <div style={{ ...crd, borderColor: "#C53030", background: "#FFF5F5", color: "#C53030", fontSize: 14 }} data-testid="interes-error">
            ⚠️ {resultado.error}
          </div>
        )}

        {/* RESULTADO */}
        {resultado && !resultado.error && (
          <div style={{ background: P.card, borderRadius: 10, border: `2px solid ${P.success}`, overflow: "hidden", marginBottom: 14 }} data-testid="interes-resultado">
            <div style={{ background: P.successBg, padding: "18px 20px", borderBottom: `1px solid ${P.success}33` }}>
              <div style={{ display: "flex", flexWrap: "wrap", gap: 24 }}>
                <div>
                  <div style={{ fontSize: 10, color: P.muted, textTransform: "uppercase", fontWeight: 700, letterSpacing: "0.06em" }}>Total intereses</div>
                  <div style={{ fontFamily: F.display, fontSize: 28, fontWeight: 700, color: P.success }} data-testid="interes-total">{fmtMoney(resultado.totalInterest)}</div>
                </div>
                <div>
                  <div style={{ fontSize: 10, color: P.muted, textTransform: "uppercase", fontWeight: 700, letterSpacing: "0.06em" }}>Capital + Intereses</div>
                  <div style={{ fontFamily: F.display, fontSize: 28, fontWeight: 700, color: P.text }}>{fmtMoney(resultado.totalWithCapital)}</div>
                </div>
              </div>
              <div style={{ display: "flex", gap: 14, marginTop: 10, fontSize: 11, color: P.muted, flexWrap: "wrap" }}>
                <span><strong>Capital:</strong> {fmtMoney(resultado.capital)}</span>
                <span><strong>Período:</strong> {fmtDate(resultado.fechaDesde)} → {fmtDate(resultado.fechaHasta)}</span>
                <span><strong>Días totales:</strong> {resultado.totalDays}</span>
              </div>

              {resultado.hasTwoPhases && (
                <div style={{ display: "flex", gap: 12, marginTop: 14, flexWrap: "wrap" }}>
                  <div style={{ flex: 1, minWidth: 180, padding: "10px 14px", background: "white", borderRadius: 8, border: `2px solid ${resultado.preColor}` }}>
                    <div style={{ fontSize: 10, fontWeight: 700, color: resultado.preColor, textTransform: "uppercase" }}>① {resultado.preLabel}</div>
                    <div style={{ fontSize: 11, color: P.muted, marginTop: 2 }}>{fmtDate(resultado.fechaDesde)} → {fmtDate(resultado.fechaSentencia)} · {resultado.preDays} días</div>
                    <div style={{ fontSize: 18, fontWeight: 700, color: resultado.preColor, fontFamily: F.display, marginTop: 4 }}>{fmtMoney(resultado.preTotalInterest)}</div>
                  </div>
                  <div style={{ flex: 1, minWidth: 180, padding: "10px 14px", background: "white", borderRadius: 8, border: `2px solid ${resultado.postColor}` }}>
                    <div style={{ fontSize: 10, fontWeight: 700, color: resultado.postColor, textTransform: "uppercase" }}>② {resultado.postLabel}</div>
                    <div style={{ fontSize: 11, color: P.muted, marginTop: 2 }}>{fmtDate(resultado.fechaSentencia)} → {fmtDate(resultado.fechaHasta)} · {resultado.postDays} días</div>
                    <div style={{ fontSize: 18, fontWeight: 700, color: resultado.postColor, fontFamily: F.display, marginTop: 4 }}>{fmtMoney(resultado.postTotalInterest)}</div>
                  </div>
                </div>
              )}
            </div>

            <div style={{ padding: "18px 20px" }}>
              {resultado.isArt19 && resultado.fechaCondena && (
                <div style={{ marginBottom: 14, padding: "10px 14px", background: "#B7791F11", borderRadius: 8, border: "1px solid #B7791F33", fontSize: 12, lineHeight: 1.5, color: P.text }}>
                  <strong style={{ color: "#B7791F" }}>Art. 19.1 LGCU</strong> — Régimen propio que desplaza art. 1108 CC y art. 576 LEC.
                  Condena: {fmtDate(resultado.fechaCondena)}. El mínimo del 20% se aplica desde {fmtDate((() => { const d = new Date(resultado.fechaCondena); d.setFullYear(d.getFullYear() + 2); return d; })())}.
                </div>
              )}
              <BreakdownTable
                label={resultado.hasTwoPhases ? `① Tramo pre-sentencia — ${resultado.preLabel}` : `Desglose — ${resultado.preLabel}`}
                labelColor={resultado.preColor}
                rows={resultado.preRows}
                totalDays={resultado.preDays}
                totalInterest={resultado.preTotalInterest}
                showPhase={tipoPre === "seguro_auto" || tipoPre === "art19_lgcu"}
              />

              {resultado.hasTwoPhases && resultado.postRows && (
                <BreakdownTable
                  label={`② Tramo post-sentencia — ${resultado.postLabel}`}
                  labelColor={resultado.postColor}
                  rows={resultado.postRows}
                  totalDays={resultado.postDays}
                  totalInterest={resultado.postTotalInterest}
                  showPhase={tipoPost === "seguro_auto" || tipoPost === "art19_lgcu"}
                />
              )}

              {resultado.hasTwoPhases && (
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "12px 14px", background: P.successBg, borderRadius: 8, marginTop: 4 }}>
                  <div style={{ fontWeight: 700, fontSize: 14 }}>TOTAL INTERESES (① + ②)</div>
                  <div style={{ fontWeight: 700, fontSize: 18, color: P.success, fontFamily: F.display }}>{fmtMoney(resultado.totalInterest)}</div>
                </div>
              )}

              <div style={{ marginTop: 12, padding: "8px 12px", background: P.inputBg, borderRadius: 6, fontSize: 11, color: P.muted, fontFamily: F.mono }}>
                Fórmula: Interés = (Capital × Tipo% × Días) / (365 × 100) · Interés simple
              </div>

              {/* Añadir este cálculo al informe acumulado */}
              <div style={{ marginTop: 14, padding: "12px 14px", background: P.primary + "0D", borderRadius: 8, border: `1px dashed ${P.primary}55` }}>
                <div style={{ fontSize: 12, fontWeight: 700, color: P.primary, marginBottom: 8 }}>Añadir al informe de liquidación (acumular varios conceptos)</div>
                <div style={{ display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center" }}>
                  <input
                    data-testid="interes-concepto-input"
                    value={concepto}
                    onChange={(e) => setConcepto(e.target.value)}
                    placeholder="Concepto (p. ej. Notaría)"
                    style={{ ...inp, flex: 1, minWidth: 180, marginBottom: 0 }}
                  />
                  <button
                    data-testid="interes-add-report"
                    onClick={addToReport}
                    style={{ background: P.primary, color: "white", border: "none", borderRadius: 8, padding: "10px 16px", fontWeight: 700, cursor: "pointer", fontFamily: F.body, fontSize: 13, whiteSpace: "nowrap" }}
                  >
                    ➕ Añadir al informe
                  </button>
                </div>
                <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginTop: 8 }}>
                  {["Notaría", "Gestoría", "Registro", "Tasación", "Comisión de apertura", "Otro"].map((s) => (
                    <button
                      key={s}
                      onClick={() => setConcepto(s)}
                      style={{ background: "white", color: P.primary, border: `1px solid ${P.primary}55`, borderRadius: 999, padding: "4px 10px", fontSize: 11, cursor: "pointer", fontFamily: F.body }}
                    >{s}</button>
                  ))}
                </div>
              </div>
            </div>
          </div>
        )}

        {/* CONCEPTOS ACUMULADOS */}
        {ops.length > 0 && (
          <div style={{ ...crd, borderLeft: `4px solid ${P.success}` }} data-testid="interes-ops-panel">
            <div style={{ fontSize: 14, fontWeight: 700, color: P.text, marginBottom: 10, display: "flex", alignItems: "center", gap: 8 }}>
              🧾 Conceptos en el informe <span style={{ fontSize: 11, color: P.muted }}>({ops.length})</span>
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
              {ops.map((o, i) => (
                <div key={o._id} data-testid={`interes-op-${i}`} style={{ display: "flex", alignItems: "center", gap: 10, padding: "8px 12px", background: P.inputBg, borderRadius: 8, fontSize: 12, flexWrap: "wrap" }}>
                  <span style={{ fontWeight: 700, minWidth: 140 }}>{i + 1}. {o.concepto}</span>
                  <span style={{ color: P.muted }}>Capital {fmtMoney(o.capital)}</span>
                  <span style={{ color: P.muted }}>{o.fechaDesde} → {o.fechaHasta}</span>
                  <span style={{ marginLeft: "auto", fontWeight: 700, color: P.success }}>Intereses {fmtMoney(o.totalInteres)}</span>
                  <button
                    data-testid={`interes-op-remove-${i}`}
                    onClick={() => removeOp(o._id)}
                    style={{ background: "none", border: "none", color: "#C53030", cursor: "pointer", fontWeight: 700, fontSize: 16, lineHeight: 1 }}
                    title="Quitar concepto"
                  >×</button>
                </div>
              ))}
            </div>
            {(() => { const t = opsTotals(); return (
              <div style={{ display: "flex", gap: 20, flexWrap: "wrap", marginTop: 12, padding: "12px 14px", background: P.successBg, borderRadius: 8, borderTop: `2px solid ${P.success}` }} data-testid="interes-ops-total">
                <div><div style={{ fontSize: 10, color: P.muted, fontWeight: 700, textTransform: "uppercase" }}>Suma capitales</div><div style={{ fontFamily: F.display, fontSize: 20, fontWeight: 700 }}>{fmtMoney(t.cap)}</div></div>
                <div><div style={{ fontSize: 10, color: P.muted, fontWeight: 700, textTransform: "uppercase" }}>Total intereses</div><div style={{ fontFamily: F.display, fontSize: 20, fontWeight: 700, color: P.success }}>{fmtMoney(t.inte)}</div></div>
                <div><div style={{ fontSize: 10, color: P.muted, fontWeight: 700, textTransform: "uppercase" }}>Total general</div><div style={{ fontFamily: F.display, fontSize: 20, fontWeight: 700 }}>{fmtMoney(t.tot)}</div></div>
              </div>
            ); })()}
            <button
              data-testid="interes-descargar-informe"
              onClick={descargarInforme}
              style={{ marginTop: 12, background: "#B7791F", color: "white", border: "none", borderRadius: 8, padding: "11px 18px", fontWeight: 700, cursor: "pointer", fontFamily: F.body, fontSize: 13 }}
            >
              📄 Descargar informe de liquidación (Word)
            </button>
            {descargaErr && (
              <div data-testid="interes-descarga-error" style={{ marginTop: 10, padding: "9px 12px", borderRadius: 6, background: "#FEF2F2", border: "1px solid #FCA5A5", color: "#B91C1C", fontSize: 12 }}>
                {descargaErr}
              </div>
            )}
            <div style={{ fontSize: 11, color: P.muted, marginTop: 8 }}>
              También puedes generar el escrito judicial (plantilla) con todos los conceptos en el panel de abajo.
            </div>
          </div>
        )}

        {/* PANEL: Crear escrito de proposición de intereses */}
        {((resultado && !resultado.error) || ops.length > 0) && (
          <div style={{ ...crd, borderLeft: `4px solid ${P.primary}` }} data-testid="interes-escrito-panel">
            <button
              data-testid="interes-abrir-escrito"
              onClick={abrirEscrito}
              style={{ background: "none", border: "none", cursor: "pointer", fontFamily: F.body, fontSize: 14, fontWeight: 700, color: P.primary, padding: 0, display: "flex", alignItems: "center", gap: 8 }}
            >
              <span style={{ fontSize: 18 }}>📄</span>
              {showEscrito ? "▾" : "▸"} ¿Crear escrito de proposición de intereses en un expediente?
            </button>

            {showEscrito && (
              <div style={{ marginTop: 14 }}>
                {/* Plantilla */}
                <label style={lbl}>Plantilla (Generar escrito judicial)</label>
                <select
                  data-testid="interes-plantilla-select"
                  value={plantillaSel}
                  onChange={(e) => setPlantillaSel(e.target.value)}
                  style={{ ...inp, cursor: "pointer" }}
                >
                  <option value="">— Selecciona una plantilla —</option>
                  {carpetas.length > 0
                    ? carpetas.map((c) => (
                        <optgroup key={c.id} label={c.nombre}>
                          {plantillas.filter((p) => p.carpeta_id === c.id).map((p) => (
                            <option key={p.id} value={p.id}>{p.nombre}</option>
                          ))}
                        </optgroup>
                      ))
                    : plantillas.map((p) => (
                        <option key={p.id} value={p.id}>{p.nombre}</option>
                      ))}
                  {/* plantillas sin carpeta */}
                  {carpetas.length > 0 && plantillas.some((p) => !p.carpeta_id) && (
                    <optgroup label="Sin carpeta">
                      {plantillas.filter((p) => !p.carpeta_id).map((p) => (
                        <option key={p.id} value={p.id}>{p.nombre}</option>
                      ))}
                    </optgroup>
                  )}
                </select>

                <div style={{ marginTop: 8, padding: "8px 12px", background: P.inputBg, borderRadius: 6, fontSize: 11, color: P.muted, lineHeight: 1.6 }} data-testid="interes-marcas-ayuda">
                  <strong style={{ color: P.text }}>Marcas para la plantilla:</strong> <code>{"{{INT_TOTAL}}"}</code> (suma de intereses) · <code>{"{{INT_TOTAL_CON_CAPITAL}}"}</code> (capital + intereses) · <code>{"{{INT_CAPITAL}}"}</code> · <code>{"{{INT_RESULTADO_FINAL}}"}</code> (frase para el suplico).<br />
                  La <strong>tabla de cálculos</strong> se genera como <strong>DOCUMENTAL Nº1</strong> en un Word aparte y se adjunta a la actuación (no se incrusta en el escrito).
                </div>

                {/* Expediente */}
                <div style={{ marginTop: 14, position: "relative" }}>
                  <label style={lbl}>Expediente</label>
                  <input
                    data-testid="interes-exp-search"
                    placeholder="Buscar por número de expediente o cliente…"
                    value={expSel ? `${expSel.numero_expediente} — ${expSel.cliente_nombre || ""}` : expQuery}
                    onChange={(e) => buscarExp(e.target.value)}
                    style={inp}
                  />
                  {expOpciones.length > 0 && !expSel && (
                    <div style={{ position: "absolute", zIndex: 20, background: "white", border: `1px solid ${P.border}`, borderRadius: 6, width: "100%", marginTop: 2, maxHeight: 200, overflowY: "auto", boxShadow: "0 4px 12px rgba(0,0,0,0.12)" }}>
                      {expOpciones.map((ex) => (
                        <button
                          key={ex.id}
                          data-testid={`interes-exp-opt-${ex.id}`}
                          onClick={() => { setExpSel(ex); setExpOpciones([]); }}
                          style={{ display: "block", width: "100%", textAlign: "left", padding: "8px 12px", fontSize: 13, background: "none", border: "none", cursor: "pointer", borderBottom: `1px solid ${P.border}33` }}
                        >
                          <b>{ex.numero_expediente}</b> — {ex.cliente_nombre || "Sin cliente"}
                        </button>
                      ))}
                    </div>
                  )}
                  {expSel && (
                    <p style={{ fontSize: 11, color: P.success, marginTop: 4 }}>
                      Se creará una actuación en {expSel.numero_expediente} ✓
                      <button onClick={() => { setExpSel(null); setExpQuery(""); }} style={{ marginLeft: 8, textDecoration: "underline", background: "none", border: "none", cursor: "pointer", color: P.muted, fontSize: 11 }}>quitar</button>
                    </p>
                  )}
                </div>

                {/* Opciones */}
                <label style={{ display: "flex", alignItems: "center", gap: 8, marginTop: 14, fontSize: 13, cursor: "pointer" }}>
                  <input type="checkbox" data-testid="interes-descargar-check" checked={descargarDoc} onChange={(e) => setDescargarDoc(e.target.checked)} style={{ width: 16, height: 16, accentColor: P.primary }} />
                  Descargar también el .docx en mi navegador
                </label>

                <button
                  data-testid="interes-generar-escrito-btn"
                  onClick={generarEscrito}
                  disabled={genEscrito}
                  style={{ marginTop: 14, width: "100%", padding: "12px", background: genEscrito ? P.muted : P.primary, color: "white", border: "none", borderRadius: 8, fontSize: 15, fontWeight: 700, fontFamily: F.body, cursor: genEscrito ? "wait" : "pointer" }}
                >
                  {genEscrito ? "Generando escrito…" : "Generar escrito y crear actuación"}
                </button>

                {escritoErr && (
                  <div style={{ marginTop: 10, padding: "8px 12px", borderRadius: 6, background: "#FFF5F5", border: "1px solid #C5303044", fontSize: 12, color: "#C53030" }} data-testid="interes-escrito-error">
                    ⚠️ {escritoErr}
                  </div>
                )}

                {escritoRes && escritoRes.ok && (
                  <div style={{ marginTop: 12, padding: "12px 14px", borderRadius: 8, background: P.successBg, border: `1px solid ${P.success}44` }} data-testid="interes-escrito-ok">
                    <div style={{ fontWeight: 700, color: P.success, fontSize: 13, marginBottom: 4 }}>
                      ✓ Escrito generado y actuación creada
                    </div>
                    <div style={{ fontSize: 12, color: P.text }}>
                      "{escritoRes.actuacion?.titulo}" en el expediente {expSel?.numero_expediente}
                      {escritoRes.actuacion?.documentosAdjuntos ? ` · ${escritoRes.actuacion.documentosAdjuntos} documento(s) adjuntado(s) ✓` : ""}
                    </div>
                    <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginTop: 8 }}>
                      {escritoRes.documento?.url && (
                        <button
                          type="button"
                          onClick={() => descargarDocumento(escritoRes.documento.url, escritoRes.documento.nombre)}
                          data-testid="interes-escrito-descargar"
                          style={{ display: "inline-flex", alignItems: "center", gap: 6, padding: "8px 14px", borderRadius: 6, background: P.primary, color: "white", fontSize: 13, fontWeight: 600, border: "none", cursor: "pointer", fontFamily: F.body }}
                        >
                          ⬇ Descargar escrito (.docx)
                        </button>
                      )}
                      {escritoRes.documental?.url && (
                        <button
                          type="button"
                          onClick={() => descargarDocumento(escritoRes.documental.url, escritoRes.documental.nombre)}
                          data-testid="interes-documental-descargar"
                          style={{ display: "inline-flex", alignItems: "center", gap: 6, padding: "8px 14px", borderRadius: 6, background: "#B7791F", color: "white", fontSize: 13, fontWeight: 600, border: "none", cursor: "pointer", fontFamily: F.body }}
                        >
                          ⬇ Descargar DOCUMENTAL Nº1 (tabla de cálculos)
                        </button>
                      )}
                    </div>
                    {Array.isArray(escritoRes.marcas) && escritoRes.marcas.length > 0 && (
                      <div style={{ marginTop: 14 }} data-testid="interes-marcas-leyenda">
                        <div style={{ fontSize: 12, fontWeight: 700, color: P.text, marginBottom: 6 }}>
                          Marcas disponibles para la plantilla (y el dato que introducen)
                        </div>
                        <div style={{ fontSize: 10, color: P.muted, marginBottom: 8 }}>
                          Copia estas marcas en tu plantilla Word donde quieras que aparezca cada dato.
                        </div>
                        <div style={{ border: `1px solid ${P.border}`, borderRadius: 8, overflow: "hidden" }}>
                          {escritoRes.marcas.map((mk, i) => (
                            <div key={mk.marca} data-testid={`interes-marca-${i}`}
                              style={{ display: "flex", flexWrap: "wrap", gap: 8, alignItems: "baseline", padding: "8px 10px", background: i % 2 ? P.inputBg : "white", borderTop: i ? `1px solid ${P.border}` : "none" }}>
                              <code style={{ fontSize: 11, fontWeight: 700, color: P.primary, whiteSpace: "nowrap" }}>{mk.marca}</code>
                              <span style={{ fontSize: 11, color: P.muted, flex: 1, minWidth: 160 }}>{mk.descripcion}</span>
                              {mk.valor != null && mk.valor !== "" ? (
                                <span style={{ fontSize: 11, fontWeight: 700, color: P.text }}>→ {mk.valor}</span>
                              ) : (
                                <span style={{ fontSize: 10, fontStyle: "italic", color: "#B7791F" }}>→ DOCUMENTAL Nº1 (Word aparte)</span>
                              )}
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                    <div style={{ marginTop: 12, borderTop: `1px solid ${P.success}33`, paddingTop: 10 }}>
                      <button
                        data-testid="interes-nuevo-calculo-ok"
                        onClick={nuevoCalculoTodo}
                        style={{ display: "inline-flex", alignItems: "center", gap: 6, padding: "9px 16px", borderRadius: 8, background: P.card, color: P.primary, border: `1px solid ${P.primary}55`, fontSize: 13, fontWeight: 700, cursor: "pointer", fontFamily: F.body }}
                      >
                        🆕 Empezar un nuevo cálculo desde cero
                      </button>
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        )}

        {/* TABLA HISTÓRICA */}
        <div style={crd}>
          <button onClick={() => setShowTable(!showTable)} data-testid="interes-toggle-tabla" style={{ background: "none", border: "none", cursor: "pointer", fontFamily: F.body, fontSize: 13, fontWeight: 600, color: P.primary, padding: 0, display: "flex", alignItems: "center", gap: 6 }}>
            <span style={{ transform: showTable ? "rotate(90deg)" : "none", transition: "0.2s", display: "inline-block" }}>▶</span>
            Tabla histórica de tipos (2000–2026)
          </button>
          {showTable && (
            <div style={{ marginTop: 12, overflowX: "auto" }}>
              <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 11, fontFamily: F.body }}>
                <thead>
                  <tr style={{ borderBottom: `2px solid ${P.border}` }}>
                    <th style={{ padding: "5px 6px", textAlign: "left", fontWeight: 700, color: P.muted, fontSize: 10 }}>AÑO</th>
                    <th style={{ padding: "5px 6px", textAlign: "right", fontWeight: 700, color: P.muted, fontSize: 10 }}>LEGAL</th>
                    <th style={{ padding: "5px 6px", textAlign: "right", fontWeight: 700, color: P.muted, fontSize: 10 }}>JUDICIAL</th>
                    <th style={{ padding: "5px 6px", textAlign: "right", fontWeight: 700, color: P.muted, fontSize: 10 }}>DEMORA TRIB.</th>
                  </tr>
                </thead>
                <tbody>
                  {[2026, 2025, 2024, 2023, 2022, 2021, 2020, 2019, 2018, 2017, 2016, 2015, 2014, 2013, 2012, 2011, 2010, 2009, 2008, 2007, 2006, 2005, 2004, 2003, 2002, 2001, 2000].map((y) => {
                    const r = getRateForDate(INTERES_LEGAL, new Date(y, 6, 1));
                    if (!r) return null;
                    return (
                      <tr key={y} style={{ borderBottom: `1px solid ${P.border}33` }}>
                        <td style={{ padding: "4px 6px", fontWeight: 600 }}>{y}</td>
                        <td style={{ padding: "4px 6px", textAlign: "right" }}>{r.toFixed(2)}%</td>
                        <td style={{ padding: "4px 6px", textAlign: "right" }}>{(r + 2).toFixed(2)}%</td>
                        <td style={{ padding: "4px 6px", textAlign: "right" }}>{(r * 1.25).toFixed(2)}%</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </div>

        <div style={{ textAlign: "center", fontSize: 10, color: P.muted, padding: "6px 0", lineHeight: 1.6 }}>
          Lex Duo Advocats SLP · Herramienta interna · Fuentes: PGE, BOE, BdE, BCE
        </div>
      </div>
    </div>
  );
}
